import { Paper, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import EasyEdit from "react-easy-edit";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";

const GeneralInfo = ({ groupID }) => {
  const [generalInfo, setGeneralInfo] = useState("");
  const [creatorName, setCreatorName] = useState(generalInfo.name);
  const [aboutText, setAboutText] = useState(generalInfo.about);
  const [locationText, setLocationText] = useState(generalInfo.location);
  const [phoneNo, setPhoneNo] = useState(generalInfo?.phone_no);
  const [facebookLink, setFacebookLink] = useState(generalInfo?.facebook_link);
  const [linkedInLink, setLinkedInLink] = useState(generalInfo?.linkedin_link);
  const [instagramLink, setInstagramLink] = useState(
    generalInfo?.instagram_link
  );
  const [otherSiteLink, setOtherSiteLink] = useState(generalInfo?.others_link);

  //Snackbar Alert
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const name = (value) => {
    setCreatorName(value);
    handleClick();
  };

  const about = (value) => {
    setAboutText(value);
    handleClick();
  };

  const location = (value) => {
    setLocationText(value);
    handleClick();
  };

  const phone = (value) => {
    setPhoneNo(value);
    handleClick();
  };

  const facebook = (value) => {
    setFacebookLink(value);
    handleClick();
  };

  const linkedIn = (value) => {
    setLinkedInLink(value);
    handleClick();
  };

  const instagram = (value) => {
    setInstagramLink(value);
    handleClick();
  };

  const otherSite = (value) => {
    setOtherSiteLink(value);
    handleClick();
  };

  const cancel = () => {
    setCreatorName(generalInfo.name);
    setAboutText(generalInfo.about);
    setLocationText(generalInfo.location);
    setPhoneNo(generalInfo.phone_no);
    setFacebookLink(generalInfo.facebook_link);
    setLinkedInLink(generalInfo.linkedin_link);
    setInstagramLink(generalInfo.instagram_link);
    setOtherSiteLink(generalInfo.others_link);
  };

  const generalInfoDetails = () => {
    fetch(`https://researchrider.xyz/group/${groupID}/group-detail/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setGeneralInfo(data.group);
      });
  };

  // Group General Information update

  const updateGroup = () => {
    fetch(`https://researchrider.xyz/group/${groupID}/group-update/`, {
      method: "PATCH",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: creatorName,
        about: aboutText,
        facebook_link: facebookLink,
        linkedin_link: linkedInLink,
        instagram_link: instagramLink,
        others_link: otherSiteLink,
        phone_no: phoneNo,
        location: locationText,
      }),
    })
      .then((response) => {
        response.json();
        generalInfoDetails();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    generalInfoDetails();
  }, [groupID]);

  useEffect(() => {
    if (
      generalInfo.name ||
      generalInfo.about ||
      generalInfo.location ||
      generalInfo.phone_no ||
      generalInfo.facebook_link ||
      generalInfo.linkedin_link ||
      generalInfo.instagram_link ||
      generalInfo.others_link
    ) {
      updateGroup();
    }
  }, [generalInfo]);

  return (
    <>
      <Row className="mb-3">
        <Paper className="p-4 rounded-3" elevation={0}>
          <h5 className="mb-4">General Information</h5>
          <Col>
            {/* -----Group Creator-----  */}
            <div>
              <h6>Group Name</h6>
              <div
                style={{ backgroundColor: "#ECECEC" }}
                className="p-3 rounded-4"
              >
                <EasyEdit
                  type="text"
                  value={generalInfo.name ? generalInfo.name : "Add Name"}
                  onSave={name}
                  onCancel={cancel}
                  saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                  cancelButtonLabel={<HighlightOffRoundedIcon />}
                />
              </div>
            </div>

            {/* -----About section-----  */}
            <div className="py-2">
              <h6>About</h6>
              <div
                style={{ backgroundColor: "#ECECEC" }}
                className="p-3 rounded-4"
              >
                <EasyEdit
                  type="text"
                  value={generalInfo.about ? generalInfo.about : "Add About"}
                  onSave={about}
                  onCancel={cancel}
                  saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                  cancelButtonLabel={<HighlightOffRoundedIcon />}
                />
              </div>
            </div>

            {/* -----Location section-----  */}
            <div className="py-2">
              <h6>Location</h6>
              <div
                style={{ backgroundColor: "#ECECEC" }}
                className="p-2 rounded-4"
              >
                <EasyEdit
                  type="text"
                  value={
                    generalInfo.location ? generalInfo.location : "Add location"
                  }
                  onSave={location}
                  onCancel={cancel}
                  saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                  cancelButtonLabel={<HighlightOffRoundedIcon />}
                />
              </div>
            </div>

            {/* -----Phone number section-----  */}
            <div className="py-2">
              <h6>Phone number</h6>
              <div
                style={{ backgroundColor: "#ECECEC" }}
                className="p-2 rounded-4"
              >
                <EasyEdit
                  type="text"
                  value={
                    generalInfo.phone_no
                      ? generalInfo.phone_no
                      : "Add Phone No."
                  }
                  onSave={phone}
                  onCancel={cancel}
                  saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                  cancelButtonLabel={<HighlightOffRoundedIcon />}
                />
              </div>
            </div>

            {/* -----Website link section-----  */}
            <div className="py-2">
              <h6>Website link</h6>

              <div className="d-flex align-items-center">
                <FacebookIcon sx={{ color: "#1877f2", fontSize: "28px" }} />
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <EasyEdit
                    type="text"
                    value={
                      generalInfo.facebook_link
                        ? generalInfo.facebook_link
                        : "Add facebook Link"
                    }
                    onSave={facebook}
                    onCancel={cancel}
                    saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                    cancelButtonLabel={<HighlightOffRoundedIcon />}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center py-2">
                <LinkedInIcon sx={{ color: "#1877f2", fontSize: "28px" }} />
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <EasyEdit
                    type="text"
                    value={
                      generalInfo.linkedin_link
                        ? generalInfo.linkedin_link
                        : "Add linkedIn Link"
                    }
                    onSave={linkedIn}
                    onCancel={cancel}
                    saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                    cancelButtonLabel={<HighlightOffRoundedIcon />}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center">
                <InstagramIcon sx={{ color: "#ac3ba5", fontSize: "28px" }} />
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <EasyEdit
                    type="text"
                    value={
                      generalInfo.instagram_link
                        ? generalInfo.instagram_link
                        : "Add Instagram Link"
                    }
                    onSave={instagram}
                    onCancel={cancel}
                    saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                    cancelButtonLabel={<HighlightOffRoundedIcon />}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center">
                <LanguageOutlinedIcon
                  sx={{ color: "#405DE6", fontSize: "28px" }}
                />
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <EasyEdit
                    type="text"
                    value={
                      generalInfo?.others_link
                        ? generalInfo?.others_link
                        : "Add your website"
                    }
                    onSave={otherSite}
                    onCancel={cancel}
                    saveButtonLabel={<CheckCircleOutlineRoundedIcon />}
                    cancelButtonLabel={<HighlightOffRoundedIcon />}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Paper>
      </Row>

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Successfully update group information
        </Alert>
      </Snackbar>
    </>
  );
};

export default GeneralInfo;
